import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Referrer } from '../../classes/referrer';
import { ReferrerService } from '../../services/referrer';
import { AuthService } from '../../services/auth';
import { User } from '../../classes/user';
import { referrerEmailError, referrerNameError, referrerSurnameError } from '../../utils/referrerValidation';

@Component({
    selector: 'app-referrer-update',
    templateUrl: './referrer-update.component.html',
    styleUrls: ['./referrer-update.component.css']
})
export class ReferrerUpdateComponent implements OnInit {
    user: User = new User();
    referrer: Referrer = new Referrer();
    submitted: boolean = false;
    loadingCondition: boolean = false;
    formError: string = '';

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private referrerService: ReferrerService) {
    }

    ngOnInit(): void {
        this.authService.isUserSignedIn()
            .subscribe({
                next: () => {
                    this.authService.getUser()
                        .subscribe({
                            next: (user: any) => {
                                this.user = user;
                                if (this.user.FKIDUserRole !== 1) {
                                    this.router.navigate(['/dashboard']);
                                    return;
                                }
                                this.loadReferrer();
                            },
                            error: () => {
                                this.router.navigate(['/login']);
                            }
                        });
                },
                error: () => {
                    this.router.navigate(['/login']);
                }
            });
    }

    private loadReferrer(): void {
        this.route.paramMap.subscribe(params => {
            this.referrerService.getByID(params.get('id'))
                .subscribe({
                    next: (referrer: Referrer) => {
                        this.referrer = referrer;
                    },
                    error: (err: HttpErrorResponse) => {
                        this.formError = err.status === 404
                            ? 'Segnalatore non trovato.'
                            : 'Non è stato possibile caricare il segnalatore.';
                    }
                });
        });
    }

    get nameError(): string | null {
        return this.submitted ? referrerNameError(this.referrer.Name) : null;
    }

    get surnameError(): string | null {
        return this.submitted ? referrerSurnameError(this.referrer.Surname) : null;
    }

    get emailError(): string | null {
        return this.submitted ? referrerEmailError(this.referrer.Email) : null;
    }

    saveAndGoToList() {
        if (this.loadingCondition) {
            return;
        }
        this.submitted = true;
        this.formError = '';
        if (this.nameError || this.surnameError || this.emailError) {
            return;
        }
        this.referrer.Name = this.referrer.Name.trim();
        this.referrer.Surname = this.referrer.Surname.trim();
        this.referrer.Email = this.referrer.Email.trim();
        this.loadingCondition = true;
        this.referrerService.update(this.referrer)
            .subscribe({
                next: () => {
                    this.loadingCondition = false;
                    this.router.navigate(['/segnalatori']);
                },
                error: (err: HttpErrorResponse) => {
                    this.loadingCondition = false;
                    this.formError = err.error?.message || 'Non è stato possibile salvare il segnalatore.';
                }
            });
    }
}
